import gql from 'graphql-tag';

export const PORTAL_ORDER_ITEMS_QUERY = gql`
    query portalOrderItems(
        $operatorId: String!,
        $skip: Int,
        $first: Int,
        $startCaptureDate: String,
        $endCaptureDate: String,
        $startDate: String,
        $endDate: String,
    )
    {
    portalOrderItems(
        operatorId: $operatorId,
        skip: $skip,
        first: $first,
        startDate: $startDate,
        endDate: $endDate,
        startCaptureDate: $startCaptureDate,
        endCaptureDate: $endCaptureDate
    ) {
        itemsCount,
        billsAmount,
        fareAmount,
        customAmount,
        remnantAmount,
        orderItems {
            id,
            title,
            type,
            description,
            amount,
            order {
                protocol
                portalOrder {
                    id
                }
            }
        }

    }
    }
`;



// WEBPACK FOOTER //
// ./src/components/Pages/Items/graphql.js